import { InMemoryWebStorage, UserManager, WebStorageStateStore } from "oidc-client-ts";

const store = new WebStorageStateStore({ store: new InMemoryWebStorage() });

export const userManager = new UserManager({
  authority: "https://shield.inulti.com",
  client_id: process.env.VUE_APP_ZITADEL_CLIENT_ID,
  popup_redirect_uri: window.location.origin + "/zitadel-callback",
  userStore: store,
  stateStore: store,
  scope: "openid profile email",
});
